import React from 'react';
import { Alert, Box, Card, CardContent, Chip, Typography } from '@mui/material';
import PageHeader from '../components/common/PageHeader';

const rows: { label: string; value: string }[] = [
  { label: 'CWE', value: 'CWE-COFFEE – Improper Thermal Management of Brewing Devices' },
  { label: 'CVSS', value: '11.0 (Kaffee), Vektor AV:K/AC:L/PR:N. Wird nicht gespeichert.' },
  {
    label: 'Management Summary',
    value: 'Der Kaffeeautomat liegt außerhalb jedes Kunden-Scopes. Auswirkung: die nächste Tasse dauert länger als der letzte Commit.',
  },
  { label: 'Mitigation', value: 'Neu starten, dann nachfüllen.' },
];

/** Nicht speicherbare Scherzkarte. Kein Finding, kein API-Schreibzugriff. */
const KaffeePage: React.FC = () => {
  return (
    <Box>
      <PageHeader
        title="Ungepatchter Kaffeeautomat"
        subtitle="Easter Egg. Diese Karte legt kein Finding an."
        breadcrumbs={[{ label: 'Kaffeeküche' }]}
      />
      <Alert severity="info" sx={{ mb: 2 }}>
        Sichtbar nur in der angemeldeten Oberfläche. Nichts davon geht in Berichte, Rechnungen oder an Kunden.
      </Alert>
      <Card>
        <CardContent>
          <Chip label="Scherzkarte" size="small" color="secondary" sx={{ mb: 2 }} />
          {rows.map((row) => (
            <Box key={row.label} sx={{ mb: 2 }}>
              <Typography variant="overline" color="text.secondary">
                {row.label}
              </Typography>
              <Typography>{row.value}</Typography>
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
};

export default KaffeePage;
